export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#111827] tracking-tight">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmailStatusBanner({ configured }) {
  if (configured) return null;
  return (
    <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-800 mb-6" data-testid="email-status-banner">
      <strong>Email delivery is not connected.</strong> Enquiries are being stored successfully, but external email notifications will remain pending until the Resend API is configured.
    </div>
  );
}
